import React from "react";

const BusinessPlanFillingInstructions = () => {
  return (
    <div className="content">
      <p>
        <strong>
          O Conecta Negócio – Ligações de Consumo é implementado pelo Ministério
          das Finanças (MF) em coordenação com o Ministério da Indústria e
          Comércio (MIC), como parte do Projecto de Ligações Económicas para
          Diversificação (PLED) com o apoio do Banco Mundial. O objectivo do
          programa Conecta Negócio – Ligações de Consumo é facilitar acesso ao
          financiamento para jovens moçambicanos/as com idade igual ou superior
          18 anos e impulsionar o desenvolvimento de negócios em
          cidades/distritos com grande afluxo de investimentos, principalmente
          na área de recursos naturais das províncias de Nampula, Cabo Delgado e
          Tete.
        </strong>
      </p>
      <h5>INSTRUÇÕES GERAIS DE PREENCHIMENTO</h5>
      <p>
        ● Todas as secções deste formulário são de preenchimento obrigatório
        antes do envio, ou seja, a candidatura é considerada válida se tiver
        todos os campos do plano de negócio preenchidos. Ao preencher o plano de
        negócio pelo “website”, depois de concluído, lembre-se de sempre
        “Salvar” e “Submeter”.
      </p>
      <p>
        ● Não é necessário preencher o formulário de uma única vez. O candidato
        pode preencher progressivamente, salvar e voltar a editar o plano de
        negócio a qualquer momento que quiser.
      </p>
      <p>
        ● Assim que terminar assegurar que selecciona a opção “Submeter”. Uma
        vez submetido, não é possível voltar a editar o Plano de Negócio.
      </p>
      <p>
        ● Ao preencher as tabelas financeiras na Secção 6, digite os números
        redondos, ou seja, números inteiros, sem vírgulas, espaços ou pontos.
        Ex: Quinze Mil Meticais e não Quinze Mil Meticais e Cinquenta Centavos.
        É importante que o candidato conserve o detalhe da informação que for
        usar para preencher a tabela 6.1 e 6.3 do formulário de plano de
        negócio, pois esta será solicitada pela equipa técnica do Programa
        Conecta Negócios – Ligações de Consumo.
      </p>

      <p>
        ● Qualquer tentativa provada de dupla inscrição é punida com
        desclassificação.
      </p>
      <p>
        ● Depois da submissão receberá o Número Único de Referência (NUR) que
        será usado para sua identificação no preenchimento do Plano de Negócios;
      </p>
      <p>
        ● Se tiver alguma dúvida sobre a sua candidatura, contactar através de
        info@conecta.gov.mz ou (+258) 84 76 70 958 ou (+258) 87 90 73 052. O
        limite máximo para receber a resposta são 36 horas úteis.{" "}
      </p>
      <p>
        ● É possível que seja contactado por um/a representante da nossa equipa
        para fornecer mais informações somente para o esclarecimento sobre os
        dados de candidatura.
      </p>
      <h5>NOTA IMPORTANTE:</h5>
      <p>
        ● Ao preencher as secções do formulário, não escreva o nome da sua
        empresa ou dos sócios. Se em determinada secção for necessária a sua
        identificação, por favor use o NUR, obtido na fase da candidatura ao
        programa conecta negócios – ligações de consumo.
      </p>
      <p>
        ● O número de celular utilizado no registo da sua candidatura será o seu
        NUR (Número Único de Registo). Certifique-se de que este contacto esteja
        sempre activo e funcional, pois será essencial para futuras
        comunicações.
      </p>
      <p>
        ● Em caso de esquecimento da senha de acesso à plataforma, entre em
        contacto com a equipe do Conecta Negócios – Ligações de Consumo e
        solicite a redefinição. Lembre-se: a nova senha será enviada
        exclusivamente para o e-mail registado no momento da candidatura.
      </p>
    </div>
  );
};

export default BusinessPlanFillingInstructions;
